import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AlertInboxHeaderComponent } from "@app2/alert/alert-inbox/alert-inbox-header.component";
import { AlertInboxPageComponent } from "@app2/alert/alert-inbox/alert-inbox-page.component";
import { AlertInboxSortDropdownComponent } from "@app2/alert/alert-inbox/alert-inbox-sort-dropdown.component";
import { AlertModeViewerComponent } from "@app2/alert/alert-inbox/alert-mode-viewer.component";
import { AlertSelectorComponent } from "@app2/alert/alert-inbox/alert-selector.component";
import { AlertStateChangerComponent } from "@app2/alert/alert-inbox/alert-state-changer.component";
import { AlertStateFilterComponent } from "@app2/alert/alert-inbox/alert-state-filter.component";
import { AlertStateInfoBarComponent } from "@app2/alert/alert-inbox/alert-state-info-bar.component";
import { AlertStoryAlertsTableComponent } from "@app2/alert/alert-inbox/alert-story-alerts-table.component";
import { AlertStoryModeViewerComponent } from "@app2/alert/alert-inbox/alert-story-mode-viewer.component";
import { DismissButtonComponent } from "@app2/alert/alert-inbox/dismiss-button.component";
import { DismissFormModalComponent } from "@app2/alert/alert-inbox/dismiss-form-modal.component";
import { EscalateDropdownComponent } from "@app2/alert/alert-inbox/escalate-dropdown.component";
import { ExpandEventsComponent } from "@app2/alert/alert-inbox/expand-events.component";
import { FlagFraudButtonComponent } from "@app2/alert/alert-inbox/flag-fraud-button.component";
import { FlagFraudFormModalComponent } from "@app2/alert/alert-inbox/flag-fraud-form-modal.component";
import { ImportantFieldsContainerComponent } from "@app2/alert/alert-inbox/important-field-container.component";
import { MultipleAlertStateChangerComponent } from "@app2/alert/alert-inbox/multiple-alert-state-changer.component";
import { SequenceAlertResultStepComponent } from "@app2/alert/alert-inbox/sequence-alert-result-step.component";
import { SequenceAlertResultComponent } from "@app2/alert/alert-inbox/sequence-alert-result.component";
import { SingleAlertDisplayComponent } from "@app2/alert/alert-inbox/single-alert-display.component";
import { SingleAlertStateChangerComponent } from "@app2/alert/alert-inbox/single-alert-state-changer.component";
import { SingleAlertViewComponent } from "@app2/alert/alert-inbox/single-alert-view.component";
import { SingleTriggerDisplayComponent } from "@app2/alert/alert-inbox/single-trigger-display.component";
import { TriggerAlertsTableComponent } from "@app2/alert/alert-inbox/trigger-alerts-table.component";
import { TriggerDetailsComponent } from "@app2/alert/alert-inbox/trigger-details.component";
import { TriggerHeaderComponent } from "@app2/alert/alert-inbox/trigger-header.component";
import { TriggerModeViewerComponent } from "@app2/alert/alert-inbox/trigger-mode-viewer.component";
import { UbaPanelsComponent } from "@app2/alert/alert-inbox/uba-panels.component";
import { AlertSharedModule } from "@app2/alert/alert-shared/alert-shared.module";
import { SingleAlertViewHeaderComponent } from "@app2/alert/alert-inbox/single-alert-view-header.component";
import { AlertModule } from "@app2/alert/alert.module";
import { SearchSharedModule } from "@app2/search/search-shared/search-shared.module";
import { SharedModule } from "@app2/shared/shared.module";
import { TicketSharedModule } from "@app2/ticket/shared/ticket-shared.module";
import { TriggersSharedModule } from "@app2/triggers/triggers-shared.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        // Custom modules:
        AlertModule,
        SharedModule,
        TicketSharedModule,
        TriggersSharedModule,
        SearchSharedModule,
        AlertSharedModule,
    ],
    declarations: [
        AlertInboxPageComponent,
        AlertInboxHeaderComponent,
        AlertInboxSortDropdownComponent,
        AlertModeViewerComponent,
        AlertSelectorComponent,
        AlertStateChangerComponent,
        AlertStateFilterComponent,
        AlertStateInfoBarComponent,
        AlertStoryModeViewerComponent,
        AlertStoryAlertsTableComponent,
        DismissButtonComponent,
        DismissFormModalComponent,
        EscalateDropdownComponent,
        ExpandEventsComponent,
        FlagFraudButtonComponent,
        FlagFraudFormModalComponent,
        ImportantFieldsContainerComponent,
        MultipleAlertStateChangerComponent,
        SequenceAlertResultComponent,
        SequenceAlertResultStepComponent,
        SingleAlertDisplayComponent,
        SingleAlertStateChangerComponent,
        SingleAlertViewComponent,
        SingleAlertViewHeaderComponent,
        SingleTriggerDisplayComponent,
        TriggerAlertsTableComponent,
        TriggerDetailsComponent,
        TriggerHeaderComponent,
        TriggerModeViewerComponent,
        UbaPanelsComponent,
        AlertStateInfoBarComponent,
    ],
})
export class AlertInboxModule {
    constructor() {}
}
